import { render, staticRenderFns } from "./VimeoConfirmDialog.vue?vue&type=template&id=5ecd370c&"
import script from "./VimeoConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./VimeoConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports